import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { decryptAES } from "../cryptoUtils";
import { updateUserIdSSO } from "../ApiClient3";
const LoginPage = () => {
 const [authError, setAuthError] = useState("");
 const navigate = useNavigate();
 useEffect(() => {
   const run = async () => {
    const params = new URLSearchParams(window.location.search);
    const ssoKey = params.get("key");
    console.log("URL SEARCH STRING:", window.location.search);
    console.log("KEY EXTRACTED FROM URL:", ssoKey);
     if (!ssoKey) {
       setAuthError("Authorization unsuccessful. Missing SSO key.");
       return;
     }
     try {
       const [encUserId] = ssoKey.split('|');
       const userId = decryptAES(encUserId) || '';
       if (!userId) {
         setAuthError("Authorization unsuccessful. Invalid user id.");
         return;
       }
       localStorage.setItem('ntid', userId);
       localStorage.setItem('user_ntid', userId);
       const res = await updateUserIdSSO(ssoKey, userId);
       if (res?.token) localStorage.setItem('session_token', res.token);
       const cleanUrl = `${window.location.origin}${window.location.pathname}`;
       window.history.replaceState({}, document.title, cleanUrl);
       navigate('/chat', { state: { ntid: userId } });
     } catch (e) {
       console.error('SSO login failed', e);
       setAuthError("Authorization unsuccessful.");
     }
   };
   run();
 }, [navigate]);
 if (authError) {
   return (
<div className="login-page-container">
<Sidebar showBookmarks={false} />
<div className="login-main">
<div className="login-card">
<h2 className="login-header">Authorization Unsuccessful</h2>
<p className="error-text">{authError}</p>
</div>
</div>
</div>
   );
 }
 return (
<div className="login-page-container">
<Sidebar showBookmarks={false} />
<div className="login-main">
<div className="login-card">
<h2 className="login-header">Signing you in…</h2>
<p>Please wait while we verify your session.</p>
</div>
</div>
</div>
 );
};
export default LoginPage;